import { render, staticRenderFns } from "./InNumbers.vue?vue&type=template&id=0b2295b3&"
import script from "./InNumbers.vue?vue&type=script&lang=js&"
export * from "./InNumbers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports